import { normalizePartnerCode } from '@eidas-pro/shared';

type UrlObject = { pathname: string; query?: Record<string, string | string[] | undefined>; hash?: string };

/** `?ref=CODE` only pre-fills the checkout code (affiliate spec §4.2); it is never stored. */
export function readRefParam(search: string): string | null {
    return normalizePartnerCode(new URLSearchParams(search).get('ref'));
}

export function withRef<T extends string | UrlObject>(href: T, ref: string | null): T {
    if (!ref) return href;
    if (typeof href !== 'string') {
        const target: UrlObject = href;
        if (target.query?.['ref']) return href;
        return { ...target, query: { ...(target.query ?? {}), ref } } as unknown as T;
    }
    const path = href as string;
    if (!path.startsWith('/') || path.startsWith('//')) return href;
    const [beforeHash, hash] = path.split('#', 2) as [string, string | undefined];
    const [pathname, query = ''] = beforeHash.split('?', 2) as [string, string | undefined];
    const params = new URLSearchParams(query);
    if (params.has('ref')) return href;
    params.set('ref', ref);
    return `${pathname}?${params.toString()}${hash !== undefined ? `#${hash}` : ''}` as unknown as T;
}
